import * as types from "./actionTypes";

export const loadActionTypes = (list) => ({
  type: types.LOAD_ACTION_TYPES,
  payload: list,
});
